import axios from "axios";

import { REST_API_ENDPOINT } from "@/app/lib/constants";
import { logError } from "@/app/lib/utils/logging";

const getCSRFTokenFromBackend = async () => {
  try {
    await axios.get(`${REST_API_ENDPOINT}/auth/get-csrf-token/`, {
      withCredentials: true,
    });
    // CSRF cookie is now set
  } catch (error) {
    logError(error, { tags: { component: "apiClient", action: "getCSRFToken" } });
  }
};

const getCSRFTokenFromFrontend = () => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [name, value] = cookie.split("=").map((c) => c.trim());
    if (name === "csrftoken") {
      return value;
    }
  }
  return null;
};

// Create Axios instance with configuration
const axiosInstance = axios.create({
  baseURL: REST_API_ENDPOINT,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const csrfToken = getCSRFTokenFromFrontend();

    if (!csrfToken) {
      // Fetch CSRF token if it's missing
      await getCSRFTokenFromBackend();
      config.headers["X-CSRFToken"] = getCSRFTokenFromFrontend();
    } else {
      config.headers["X-CSRFToken"] = csrfToken;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
